import api, { twUrl } from '../../utils/api';
import { QbDesktopFieldMapping } from './QbDesktop.model';

class QbDesktopService {
  static async isConnected(divisionId?: string): Promise<{
    config?: any;
    doesConfigExistInDb: boolean;
    isConnectedToConductor: boolean;
    errorMessage?: string;
  }> {
    const request = await api.get(twUrl.qbDesktopIsConnected(divisionId));

    return request.data;
  }

  static async connect(divisionId: string): Promise<string> {
    const request = await api.post(twUrl.qbDesktopConnect, { division_id: divisionId });

    return request.data;
  }

  static async disconnect(divisionId: string): Promise<void> {
    const request = await api.post(twUrl.qbDesktopDisconnect, { division_id: divisionId });

    return request.data;
  }

  static async getFieldMapping(divisionId: string): Promise<QbDesktopFieldMapping> {
    const request = await api.get(twUrl.qbDesktopFieldMapping(divisionId));

    return request.data;
  }

  static async updateFieldMapping(
    divisionId: string,
    fieldMapping: QbDesktopFieldMapping
  ): Promise<void> {
    const request = await api.put(twUrl.qbDesktopFieldMapping(divisionId), fieldMapping);

    return request.data;
  }

  static async getLastSync(): Promise<string> {
    const request = await api.get(twUrl.qbDesktopLastSync);

    return request.data;
  }

  static async syncAllInvoices(invoiceIds?: string[]): Promise<void> {
    const request = await api.post(
      twUrl.qbDesktopSyncAllInvoices,
      invoiceIds ? { invoice_ids: invoiceIds } : {}
    );

    return request.data;
  }

  static async isSyncing(): Promise<boolean> {
    const request = await api.get(twUrl.qbDesktopIsSyncing);

    return request.data;
  }

  static async getQbDesktopObjectsCsv(divisionId: string): Promise<Blob> {
    const request = await api.get(twUrl.qbDesktopObjectsCsv(divisionId), { responseType: 'blob' });

    return request.data;
  }

  static async getTbObjectsCsv(divisionId: string): Promise<Blob> {
    const request = await api.get(twUrl.tbObjectsCsv(divisionId), { responseType: 'blob' });

    return request.data;
  }

  static async updateAutoSync(divisionId: string, isAutoSyncEnabled: boolean): Promise<void> {
    const request = await api.post(twUrl.qbDesktopAutoSync(divisionId), { isAutoSyncEnabled });

    return request.data;
  }

  static async updateAutoCustomerCreate(
    divisionId: string,
    isAutoCustomerCreateEnabled: boolean
  ): Promise<void> {
    const request = await api.post(twUrl.qbDesktopAutoCustomerCreate(divisionId), {
      isAutoCustomerCreateEnabled
    });

    return request.data;
  }

  static async checkConfig(): Promise<boolean> {
    const request = await api.get(twUrl.qbDesktopCheckConfig);

    return request.data;
  }
}

export default QbDesktopService;
